//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['data', 'theme'],
  computed: {
    styles () {
			return {
				primary: {
					background: `background:${this.theme.primary};`,
					color: `color:${this.theme.primary}`
				},
				secondary: {
					background: `background:${this.theme.secondary};`,
					color: `color:${this.theme.secondary}`
				}
			}
		}
  }
}
